export class URLHelper
{
    /**
     * Converts partial url to absolute url
     * @param url 
     */
    public static Absolute(url:string):string
    {
        var link = document.createElement("a");
        link.href = url;
        let result = link.protocol+"//"+link.host+link.pathname+link.search+link.hash;
        return result;
    }
}